module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendEmergency(23)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.openAll')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendEmergency(24)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.normal')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendEmergency(25)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.disableAll')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a54eadc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/EmergencyFunctions.vue
// module id = 966
// module chunks = 2